import AmexGDAFeatured from './AmexGDAFeatured';

export default AmexGDAFeatured;
